"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[SignalingClientVideoSubscriptionConfiguration]] contains a mapping of MID to parameters for customize what remote video is received and how,
 * on an individual stream level. This can be used to update remote video sessions set up through `subscribe`
 */

var SignalingClientVideoSubscriptionConfiguration = /*#__PURE__*/_createClass(function SignalingClientVideoSubscriptionConfiguration() {
  _classCallCheck(this, SignalingClientVideoSubscriptionConfiguration);
});

exports.default = SignalingClientVideoSubscriptionConfiguration;